import { render, staticRenderFns } from "./CourseBuilderFile.vue?vue&type=template&id=3ff03d06&scoped=true&"
import script from "./CourseBuilderFile.vue?vue&type=script&lang=js&"
export * from "./CourseBuilderFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff03d06",
  null
  
)

export default component.exports